<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">角色管理</li>
            </ol>
        </div>
        <div class="content-query content-border">
            <form action="" class="form-inline">
                <router-link v-if="menus['M281']" :to="{ name: 'roleDetail' }">
                    <el-button class="btn btn-primary" type="success" size="small" icon="el-icon-circle-plus-outline" round>添加</el-button>
                </router-link>
                <el-button type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">刷新</el-button>
            </form>
        </div>
        <hr />
        <div class="title">
            <span>角色列表</span>
        </div>
        <div class="content-data" v-if="0 < roles.length">
            <el-table highlight-current-row :data="roles" border>
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column align="center" label="名称">
                    <template slot-scope="scope">
                        <span>{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="级别">
                    <template slot-scope="scope">
                        <span>{{scope.row.level}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" fixed="right" width="500px" label="操作">
                    <template slot-scope="scope">
                        <el-button v-if="menus['M281']" type="primary" size="mini" round @click="$common.goRouterLink({ name: 'roleDetail', query: { roleId: scope.row.id } })">详情</el-button>
                        <el-button v-if="menus['M9522']" @click="$common.goRouterLink({ name: 'roleBindMenu', query: { roleId: scope.row.id } })" type="primary" round size="mini">绑定菜单</el-button>
                        <el-button v-if="menus['M2928']" @click="$common.goRouterLink({ name: 'roleUserList', query: { roleId: scope.row.id } })" type="primary" round size="mini">查看关联用户</el-button>
                        <el-button v-if="menus['M5802']" @click="$common.goRouterLink({ name: 'roleMenuList', query: { roleId: scope.row.id } })" type="primary" round size="mini">查看关联菜单</el-button>
                        <el-button v-if="menus['M5559']" @click="deleteRole(scope.row.id)" type="danger" round size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="/role/pageRole" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            roles: [],
            query: {
                userRole:'MANAGER',
                menuLevel:0,
            },

            menus: {},
        }
    },
    created() {
        var _this = this;
        _this.menus =_this.$common.cache("menus");
    },
    methods: {
        fillData(_response) {
            var _this = this;
            _this.roles = _response.items ||[];
        },
        submitQuery(_num) {
            var _this = this;
            _this.roles = [];
            _this.$refs.pager.gotoPage(_num);
        },
        deleteRole: function(_roleId) {
            var _this = this;
            _this.$confirm('是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$common.my_ajax({
                    url: 'role/deleteRole',
                    data: {
                        roleId: _roleId
                    },
                    success: function(response) {
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.submitQuery();
                                _this.$common.authority();
                            }
                        });
                    }
                });
            }).catch(() => {
                console.log('取消删除');
            });
        },
    }
}
</script>
<style scoped>
td {
    text-align: center;
}
.table tr th{
    text-align: center; 
}
</style>